'use server'

import { apiRequest, ApiResponse } from '../request'

export type HospitalUnitType =
    | 'WARD'
    | 'ICU'
    | 'NICU'
    | 'PICU'
    | 'CCU'
    | 'SURGICAL'
    | 'EMERGENCY'
    | 'ISOLATION'
    | 'MATERNITY'
    | 'PEDIATRIC'
    | 'PSYCHIATRIC'
    | 'REHABILITATION'
    | 'DIALYSIS'
    | 'ONCOLOGY'
    | 'PALLIATIVE'
    | 'OTHER'

export interface HospitalUnit {
    id: number
    companyId: number
    hospitalId: number
    name: string
    code?: string
    type: HospitalUnitType
    floor?: string
    wing?: string
    totalBeds: number
    active: boolean
    requiresIsolation: boolean
    nursingStationPhone?: string
    medicalDirectorId?: number
    nursingDirectorId?: number
    createdAt: string
    updatedAt: string
    _count?: {
        beds: number
    }
}

export interface CreateUnitData {
    hospitalId: number
    name: string
    code?: string
    type: HospitalUnitType
    floor?: string
    wing?: string
    requiresIsolation?: boolean
    nursingStationPhone?: string
    medicalDirectorId?: number
    nursingDirectorId?: number
}

export interface UpdateUnitData extends Partial<CreateUnitData> {
    active?: boolean
}

export async function getUnits(
    companyId?: number,
    hospitalId?: number,
): Promise<ApiResponse<HospitalUnit[]>> {
    return apiRequest<HospitalUnit[]>('hospital/units', {
        params: { companyId, hospitalId },
    })
}

export async function getUnitsByHospital(
    hospitalId: number,
): Promise<ApiResponse<HospitalUnit[]>> {
    return apiRequest<HospitalUnit[]>(`hospital/units/hospital/${hospitalId}`, {})
}

export async function getUnit(id: number): Promise<ApiResponse<HospitalUnit>> {
    return apiRequest<HospitalUnit>(`hospital/units/${id}`, {})
}

export async function createUnit(
    data: CreateUnitData
): Promise<ApiResponse<HospitalUnit>> {
    return apiRequest<HospitalUnit>('hospital/units', { data }, 'post')
}

export async function updateUnit(
    id: number,
    data: UpdateUnitData
): Promise<ApiResponse<HospitalUnit>> {
    return apiRequest<HospitalUnit>(`hospital/units/${id}`, { data }, 'patch')
}

export async function deleteUnit(id: number): Promise<ApiResponse<void>> {
    return apiRequest<void>(`hospital/units/${id}`, {}, 'delete')
}

export const UNIT_TYPE_LABELS: Record<HospitalUnitType, string> = {
    WARD: 'Enfermaria',
    ICU: 'UTI',
    NICU: 'UTI Neonatal',
    PICU: 'UTI Pediatrica',
    CCU: 'Unidade Coronariana',
    SURGICAL: 'Centro Cirurgico',
    EMERGENCY: 'Emergencia',
    ISOLATION: 'Isolamento',
    MATERNITY: 'Maternidade',
    PEDIATRIC: 'Pediatria',
    PSYCHIATRIC: 'Psiquiatria',
    REHABILITATION: 'Reabilitacao',
    DIALYSIS: 'Dialise',
    ONCOLOGY: 'Oncologia',
    PALLIATIVE: 'Cuidados Paliativos',
    OTHER: 'Outro',
}
